import api from "./config/axiosWith401Redirect";

const SAMPLE_URL = "/viewer/materials";

export const getSamples = async () => {
  const response = await api.get(`${SAMPLE_URL}/`);
  const samples = response.data;
  return samples;
};
